import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom';

import ShipmentOrderDetails from "@pages/ShipmentOrder/Details/Details";

// 出货单
class ShipmentOrderRouter extends PureComponent{
    render() {
        return (
            <Switch>

                <Route path="/shipmentOrder/details" component={ShipmentOrderDetails} />
                <Route path="/*" render={(props) => <Redirect to="/shipmentOrder/details" />} />
            </Switch>
        );
    }
}
export default ShipmentOrderRouter;